import { NgxSpinnerService } from 'ngx-spinner';
import { ToastrService } from 'ngx-toastr';
import { CommonService } from './common.service';
import { HttpHeaders } from '@angular/common/http';
import { BindingFlags } from '@angular/compiler/src/core';
import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Router, RouterStateSnapshot } from '@angular/router';
import { Observable, of } from 'rxjs';
import { CacheService } from './cache.service';
import { TranslateService } from '@ngx-translate/core';
import { GOODWILL_CONSTANT } from './../utils/constant';
import { error } from 'protractor';
import localeNb from '@angular/common/locales/nb';
import { registerLocaleData } from '@angular/common';
registerLocaleData(localeNb, 'nb');

@Injectable({
  providedIn: 'root'
})
export class AuthenticationService {

  constructor(
    private router: Router,
    private cacheService: CacheService,
    private translationService: TranslateService,
    private toastrService: ToastrService,
    private commonService: CommonService) { }

  // Method to handle to athentication failure of the user
  public unauthenticateUser() {
    //this.isValidUser = false;
    //this.isValidRole = false
    this.cacheService.clear();
    //this.dialogRef.closeAll();
    this.router.navigate(['/']);
    //this.translationService.loadTranlationForLocale(DPO_CONSTANT.DEFAULT_LOCALE);
  }

  async validateToken(token: string): Promise<Observable<boolean>> {
    let flag: boolean;
    this.cacheService.clear();
    if (token) {
      let isUserValid = <boolean>await this.authenticateByToken(token);
      flag = isUserValid;
    } else {
      this.unauthenticateUser();
      flag = false;
    }
    //return flag;
    return of(flag);
  }


  // Method to call the authentication API based on Token
private authenticateByToken(token: string): Promise<boolean> {
  let flag: boolean = false;
  return new Promise((resolver) => {
    const startTime = new Date().getTime(); 
    setTimeout(() => {
      this.commonService.authenticateToken(token).subscribe(
        (response) => {
          const endTime = new Date().getTime(); 
          const timeTaken = endTime - startTime;  
          console.log(`Time taken for response: ${timeTaken} ms`); 
            
            if (response) {
            sessionStorage.clear(); // This will remove all key-value pairs from sessionStorage
            
            flag = true;

            this.cacheService.setItem(GOODWILL_CONSTANT.CACHE_JWT_TOKEN, token);
              this.cacheService.setItem(GOODWILL_CONSTANT.CACHE_JWT_TOKEN_RESPONSE, response);
              this.cacheService.setItem(GOODWILL_CONSTANT.CACHE_JWT_REPAIRER_CITY, response['repairerCity']);
              this.cacheService.setItem(GOODWILL_CONSTANT.CACHE_JWT_PHYSICAL_SITE, response['physicalSite']);
              this.cacheService.setItem(GOODWILL_CONSTANT.CACHE_JWT_COMPANY_NAME, response['CompanyName']);
              this.cacheService.setItem(GOODWILL_CONSTANT.CACHE_JWT_REPAIRER_ZIP, response['repairerZip']);
              this.cacheService.setItem(GOODWILL_CONSTANT.CACHE_JWT_ISS, response['Iss']);
              this.cacheService.setItem(GOODWILL_CONSTANT.CACHE_JWT_REPAIRER_NAME, response['repairerName']);
              this.cacheService.setItem(GOODWILL_CONSTANT.CACHE_JWT_LANGUAGE, this.getLanguage(response['locale']));
              this.cacheService.setItem(GOODWILL_CONSTANT.CACHE_JWT_LANGUAGE_RAW, response['language']);
              this.cacheService.setItem(GOODWILL_CONSTANT.CACHE_JWT_REPAIRER_ADDRESS, response['repairerAddress']);
              this.cacheService.setItem(GOODWILL_CONSTANT.CACHE_JWT_LOCALE, response['locale']);
              this.cacheService.setItem(GOODWILL_CONSTANT.CACHE_JWT_USER_ID, response['userID']);
              this.cacheService.setItem(GOODWILL_CONSTANT.CACHE_JWT_RRDI, response['rrdi']);
              this.cacheService.setItem(GOODWILL_CONSTANT.CACHE_JWT_REPAIRER_BRAND, response['navigationBrand']);
              this.cacheService.setItem(GOODWILL_CONSTANT.CACHE_JWT_REPAIRER_COUNTRY, response['repairerCountry']);
              this.cacheService.setItem(GOODWILL_CONSTANT.CACHE_JWT_VIN, response['vin']);
              this.cacheService.setItem(GOODWILL_CONSTANT.CACHE_JWT_EXPIRATION, response['expiration']);
              this.cacheService.setItem(GOODWILL_CONSTANT.CACHE_JWT_SOURCE_APPLICATION, response['sourceApplication']);

              const sourceApplication = response['sourceApplication'].toUpperCase();
              const isCentralUser = (sourceApplication === 'HUB');
              this.cacheService.setItem(GOODWILL_CONSTANT.CACHE_IS_CENTRAL_USER, isCentralUser);

              const vin = response['vin'];
              if (vin) {
                this.cacheService.setItem(GOODWILL_CONSTANT.CACHE_VIN_READ_ONLY, true);
              } else {
                this.cacheService.setItem(GOODWILL_CONSTANT.CACHE_VIN_READ_ONLY, false);
              }
              this.cacheService.setItem(GOODWILL_CONSTANT.CACHE_BRAND_READ_ONLY, true);
            }
            return resolver(flag);
          },
          (error) => {
            if (error && error.status && error.error) {
              this.toastrService.warning(
                this.translationService.instant(error.error.message),
                this.translationService.instant('goodwill.i18n.message.token.invalid'),
                { disableTimeOut: true }
              );
            } 
            this.unauthenticateUser();
          });
      }, 500);
    });
  }


  //DMBR-47 : Modify method for "no-NO" language - took 'nb' instead of 'no' as per new i18 guideline.
  public getLanguage(language: string) {
    if (language.length > 2) {
      const languageAr = language.split('-');
      if (languageAr[0] === 'no') {
        languageAr[0] = 'nb';
      }     
       return languageAr[0];
    } else {
      return language;
    }
  } 
}
